module.exports = __webpack_public_path__ + "static/swetha-2cc5d92e5d2b96bcc4ab7ea2942ddf5c.png";